import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import Slider from "@mui/material/Slider";
import getCroppedImg from "./cropImage"; // helper function to get cropped image

const SignatureCropper = () => {
  const [image, setImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(e.target.files[0]);
      fileReader.onload = () => {
        setImage(fileReader.result);
      };
    }
  };

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(image, croppedAreaPixels);
      setCroppedImage(croppedImage);
    } catch (e) {
      console.error(e);
    }
  }, [image, croppedAreaPixels]);

  return (
    <div>
      <h2>Upload and Crop Signature</h2>
      <input type="file" accept="image/*" onChange={handleFileChange} />

      {image && (
        <div style={{ position: "relative", width: 400, height: 300, marginTop: 20 }}>
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={4 / 1} // rectangular signature aspect
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
        </div>
      )}

      {image && (
        <div>
          <Slider
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            onChange={(e, zoom) => setZoom(zoom)}
          />
          <button onClick={showCroppedImage}>Crop Signature</button>
        </div>
      )}

      {croppedImage && (
        <div style={{ marginTop: 20 }}>
          <h3>Cropped Signature</h3>
          <img src={croppedImage} alt="Cropped Signature" />
        </div>
      )}
    </div>
  );
};

export default SignatureCropper;
